export default {
	edit: '编辑',
	delete: '删除',
	enable: '在本场景中启用',
	disable: '在本场景中停用',
	next_step: '下一步',
	skip: '跳过',
	finish_review: '完成审查',
	skip_review: '跳过审查',
	view: '查看详情',
	close: '关闭',
	cancel: '取消',
	send: '发送',
	clone: '克隆',
	open: '打开',
	sign_out: '退出登录',
	search: '搜索',
	save: '保存',
	sort_by_name: '按名称排序（A→Z）',
	sort_by_importance: '按重要性排序（高→低）',
	filter_positive: '筛选正面利益相关方',
	filter_negative: '筛选负面利益相关方',
	export: {
		excel: '导出为 Excel',
		image: '将可视化导出为图片'
	},
	click_to_select: '点击选择',
	click_to_drag: '拖放移动',
	confirm_drop: {
		message_baseline: '您正在更新基线，确认更改吗？',
		message_scenario: '您正在更新场景 {{scenarioName}}，确认更改吗？',
		likelihood: '可能性',
		impact: '影响',
		before: '之前',
		after: '之后'
	}
};
